import { render, staticRenderFns } from "./ManuscriptList.vue?vue&type=template&id=6a80c5d6&scoped=true"
import script from "./ManuscriptList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManuscriptList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ManuscriptList.vue?vue&type=style&index=0&id=6a80c5d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a80c5d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a80c5d6')) {
      api.createRecord('6a80c5d6', component.options)
    } else {
      api.reload('6a80c5d6', component.options)
    }
    module.hot.accept("./ManuscriptList.vue?vue&type=template&id=6a80c5d6&scoped=true", function () {
      api.rerender('6a80c5d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/proofreading/revising/ManuscriptList.vue"
export default component.exports